export default "__VITE_ASSET__BCEQR3Eg__"